<template>
  <!-- 18 13 -->
  <!-- eslint-disable-next-line max-len -->
  <path d="M3.3 7.5H17c.5 0 1-.4 1-1s-.4-1-1-1H3.3l3.8-3.9c.4-.4.4-1 0-1.4s-1-.4-1.4 0L.3 5.8c-.4.4-.4 1 0 1.4l5.4 5.5c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L3.3 7.5z"/>
</template>
